import Vue from 'vue'
import Vuex from 'vuex'

// import * as actions from './actions';
import user from './modules/user'
import project from './modules/project'
import category from './modules/category'
import media from './modules/media'
import quota from './modules/quota'
import income from './modules/income'
import order from './modules/order'
import withdraw from './modules/withdraw'
import organization from './modules/organization'
import apis from './modules/apis'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const SNEAKY_MODE = 'SNEAKY_MODE'     // 是否是隐藏访问
const TBC_MODE = 'TBC_MODE'           // 时代光华模式

let i18nInstance = null // reference to i18n instance

const store = new Vuex.Store({
  state: { sneakyMode: false, tbcMode: false },
  modules: { user, project, category, media, quota, income, order, withdraw, organization, apis },
  actions: {
    set_sneaky_mode({ commit, state }, enabled) {
      if (state.sneakyMode !== enabled) {
        commit(SNEAKY_MODE, enabled)
      }
    },
    // alter tbcMode    -> tbc stands for 时代光华
    set_tbc_mode({ commit, state }, enabled) {
      if (state.tbcMode !== enabled) {
        commit(TBC_MODE, enabled)

        // alter i18 locale to company required
        // 之所以放在这儿而不是通过外面watch，是因为watch后的function执行是延迟于dom mounted的
        // 这样会有闪动
        if (enabled) {
          i18nInstance.locale = 'tbc'
        }
      }
    },
    // use to refresh all necessary vuex state as much as possible
    refresh({ dispatch }) {
      return dispatch('user/get', { force: true })
    }
  },
  mutations: {
    [SNEAKY_MODE](state, enabled) {
      state.sneakyMode = enabled
    },
    [TBC_MODE](state, enabled) {
      state.tbcMode = enabled
    }
  },
  strict: debug
})

export function createStore(i18n) {
  i18nInstance = i18n
  return store
}



// WEBPACK FOOTER //
// ./src/store/index.js